import { Capacitor } from "@capacitor/core";

// The native app is served from https://localhost / capacitor://localhost, so a
// missing or relative API URL can never work there. Builds that skip
// .env.mobile (e.g. a plain `npm run build` from an IDE plugin) fall back to
// production instead of shipping a broken app.
const isNative = Capacitor.isNativePlatform();
const PRODUCTION_API_URL = "https://thedeepam.com/api";
const PRODUCTION_GOOGLE_CLIENT_ID = "479292658971-7menh4v46v8gislq001vdgecs0deveau.apps.googleusercontent.com";

export const CLIENT_ID: string =
  import.meta.env.VITE_GOOGLE_CLIENT_ID || (isNative ? PRODUCTION_GOOGLE_CLIENT_ID : "");
// Native Google sign-in uses the apps' own clients (see MOBILE.md). The *server*
// client is the web-type client in the same Google project that the app asks
// Google to issue ID tokens for; the backend accepts it as an audience.
export const GOOGLE_ANDROID_SERVER_CLIENT_ID: string =
  import.meta.env.VITE_GOOGLE_ANDROID_SERVER_CLIENT_ID || CLIENT_ID;
export const GOOGLE_IOS_CLIENT_ID = import.meta.env.VITE_GOOGLE_IOS_CLIENT_ID;
export const GOOGLE_IOS_SERVER_CLIENT_ID: string =
  import.meta.env.VITE_GOOGLE_IOS_SERVER_CLIENT_ID || CLIENT_ID;
const envApiUrl: string | undefined = import.meta.env.VITE_API_URL;
// http://localhost:… is allowed: .env.mobile-local builds reach the Mac's
// backend through `adb reverse` (Android) or the Simulator's shared localhost.
export const API_BASE_URL = isNative && !/^https?:\/\//.test(envApiUrl || "") ? PRODUCTION_API_URL : envApiUrl;
// Origin for links that leave the app (share links, analytics page URLs). On the
// website it's wherever the page is served from; in the app it's the public site,
// because https://localhost / capacitor://localhost mean nothing to anyone else.
export const PUBLIC_SITE_URL =
  isNative || typeof window === "undefined" ? "https://thedeepam.com" : window.location.origin;
export const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || "G-C49PWMX4JT";
export const ITEMS_PER_PAGE = 10;
